import React from "react";
import styled from "styled-components";


const ErrorBoundaryWrapper = styled.div`
    max-width: 1200px;
    margin-left: 15px;
`

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, info: null, error: null };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true, error, info });
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorBoundaryWrapper>
          <h1>Oops...Something went wrong. (client) </h1>
          <div> {this.state.error.message} </div>
          <br />
          <div> {this.state.info.componentStack} </div>
        </ErrorBoundaryWrapper>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/ErrorBoundary.js